import type { Client } from "../client";
import type { NewTriggerResource, TriggerResource } from "../resources";
import type { TriggerExecutionResource } from "../resources/triggerExecutionResource";
import { BasicRepository } from "./basicRepository";
export class ProjectTriggerRepository extends BasicRepository<TriggerResource, NewTriggerResource> {
    constructor(client: Client) {
        super("ProjectTriggers", client);
    }
    getLastExecution(projectTrigger: TriggerResource): Promise<TriggerExecutionResource> {
        return this.client.get<TriggerExecutionResource>(`~/bff/spaces/{spaceId}/projecttriggerslastexecution/{projectTriggerId}`, {
            spaceId: projectTrigger.SpaceId,
            projectTriggerId: projectTrigger.Id,
        });
    }
}
